var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIc1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "#C0DCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 50,
    height: 38,
    rx: 1,
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 17.4477 13.4477 17 14 17H66C66.5523 17 67 17.4477 67 18V25H13V18Z",
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H67V32C67 32.5523 66.5523 33 66 33H14C13.4477 33 13 32.5523 13 32V25Z",
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 14,
    width: 22,
    height: 21,
    rx: 1,
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47C29 46.4477 29.4477 46 30 46H40V64H29V47Z",
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46H50C50.5523 46 51 46.4477 51 47V64H40V46Z",
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.504 29.0003H39.696V27.2003H38.052C37.656 27.2003 37.044 27.2603 36.6 27.3203C37.968 25.9403 39.288 24.2483 39.288 22.7123C39.288 21.0083 38.088 19.9043 36.36 19.9043C35.088 19.9043 34.272 20.3603 33.396 21.2843L34.56 22.4363C34.98 21.9803 35.46 21.5723 36.072 21.5723C36.78 21.5723 37.236 22.0163 37.236 22.8323C37.236 24.1283 35.736 25.7483 33.504 27.7763V29.0003Z",
    fill: "#288BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6165 25.1483L43.6365 23.3843C43.8885 22.8803 44.1285 22.3643 44.3565 21.8603H44.4045C44.3805 22.4243 44.3205 23.2763 44.3205 23.8403V25.1483H42.6165ZM47.3085 25.1483H46.3125V20.0723H43.6845L40.5765 25.2923V26.7683H44.3205V29.0003H46.3125V26.7683H47.3085V25.1483Z",
    fill: "#288BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic_1.53ff4a618f0c7db5d9d2dc8972ef3e26.svg";
export { ForwardRef as ReactComponent };